export const checkIsInternalLink = (link: string) => {
  return !(link.startsWith('http') && !link.startsWith(window.location.origin));
};
